module.exports = __webpack_public_path__ + "img/MapClose.319832f8.png";